import {
  faSquareCheck,
  faRectangleList,
  faShareFromSquare,
  faFileLines,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faPenNib, faCheckCircle} from "@fortawesome/free-solid-svg-icons";
import { faScrewdriverWrench } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { IHomePageProps } from "./IHomePage";
import HomePageMenu from "./HomePageMenu";
import SectionBlock from "./SectionBlock/SectionBlock";
import "./HomePage.scss";
import { CheckCircleOutlined } from "@ant-design/icons";

const HomePage = (props: IHomePageProps) => {
  const {
    logout,
    language,
    setLanguage,
    availableLanguages,
    translations,
	userLogo,
	userPrimaryColor,
	menuItems,
	isInvestor,
	  externalContractInvestors
  } = props;
  const navigate = useNavigate();

  let icons = {
    "Form Contract": faFileLines,
    "Overview": faRectangleList,
    "External Contract": faSquareCheck,
    "Transfer Contract": faShareFromSquare,
	"External Contract User": faPenNib,
	"NoExternalContracts": faCheckCircle,
    "Administration": faScrewdriverWrench,
  };

  const mapSectionBlock = (item: any, i: number) => (
    <SectionBlock
      key={`${item.url}_${i}`}
      options={
        !isInvestor ? (
          item.items.map((subItem: any, index: number) => {
            return (
                <button
                  key={index}
                  className="section-btn"
                  onClick={() => navigate(subItem.url)}
                >
				  <p>{translations.access}</p>
                  <FontAwesomeIcon icon={faAngleRight} />
                </button>
            );
          })
        ) : (
		//Investors
         externalContractInvestors?.length > 0 ? 
		 externalContractInvestors?.map((subItem: any, index: number) => {
			return (
				<button
					key={index}
					className="section-btn btn-investors"
					onClick={() => navigate(`/FormContract?hash=${subItem.hash}`)}
				>
					<p>{subItem.investorName}</p>
					<FontAwesomeIcon icon={faAngleRight} />
				</button>
			);
		  })
		  : (
			[
			<div className="no-external-contracts">
				<CheckCircleOutlined 
					style={{ color: '#116f11', fontSize: "30px" }}
				/>
				{translations.noExternalContracts}
			</div>
			]
		  )
        )
      }
      icon={icons[item.menu as keyof typeof icons]}
      title={translations[item.menu.replaceAll(" ", "")]}
    />
  );

  return (
    <div className="qf-homepage">
      <HomePageMenu
        logout={logout}
        language={language}
        setLanguage={setLanguage}
        availableLanguages={availableLanguages}
        userLogo={userLogo}
      />
      <div className="support-content">
        <div className="title">
          <p>
            {translations.welcome} <br />
            <span>
              <FontAwesomeIcon
                icon={faAngleRight}
                style={{ color: userPrimaryColor }}
              />
            </span>
            <strong> Bookbuilding </strong>
          </p>
        </div>
        <div className="sections-grid">
          {!isInvestor && menuItems.map((item: any, index: number) => {
            if (item.menu !== "Home") {
              return mapSectionBlock(item, index);
            }
            return null;
          })}
          {isInvestor && mapSectionBlock({
			menu: "External Contract User",
			items: [
			  {
				url: "/FormContract",
			  },
			],
		  }, 0)}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
